const SET_LANGUAGE = 'SET_LANGUAGE'

let initialState = {
    language: 'ru'
}

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE:
            return { ...state, language: action.language }
        default:
            return state;
    }
}

const setLanguage = (language) => ({ type: SET_LANGUAGE, language })


export const changeLanguage = (language) => async (dispatch) => {
    dispatch(setLanguage(language))
}



export default languageReducer;